import type { AfterViewInit, OnDestroy } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import ResizeObserver from 'resize-observer-polyfill';
import { HeaderService } from '@studiobuki/web-core/lib/header';
import { DiscountService } from 'src/app/services/discount.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopbarComponent implements AfterViewInit, OnDestroy {
  @ViewChild('wrap') wrapRef!: ElementRef<HTMLDivElement>;

  // @Output() topbarHeightChange = new BehaviorSubject(0);

  public message$ = this._discountService.activeDiscountCampaignMessage$;

  private readonly _resizeObserver = new ResizeObserver((entries) => {
    entries.forEach(({ contentRect: { height } }) => {
      this._updateTopbarHeight(height);
    });
  });

  constructor(
    private _headerService: HeaderService,
    private _discountService: DiscountService,
  ) {}

  ngAfterViewInit() {
    this._resizeObserver.observe(this.wrapRef.nativeElement);
  }

  ngOnDestroy() {
    this._resizeObserver.disconnect();
    this._headerService.topbarHeight$.next(0);
  }

  private _updateTopbarHeight(height: number) {
    if (this._headerService.topbarHeight$.value !== height) {
      this._headerService.topbarHeight$.next(height);
    }
  }
}
